import React from "react"
import QuestionPage from "../../templates/seo-collection/QuestionPage"

const Page = () => <QuestionPage destinationKey="tuscany" questionKey="luxuryCost" locale="fr" />

export default Page
